import { resolve } from 'rsvp';
import Service, { inject as service } from '@ember/service';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

/**
 * Service for location related API calls.
 */
export default Service.extend({
  api: service(),
  store: service(),
  shData: service(),
  session: service(),

  /**
   * @param {{ place_id: string }|undefined|null} place
   * @returns {Promise<DS.Model|null>}
   */
  createLocationFromGooglePlace(place) {
    if (!place) {
      return resolve(null);
    }

    if (typeof place === 'string') {
      place = { place_id: place };
    }

    const options = {
      jsonData: {
        'place_id': place.place_id,
      },
    };

    const prefix = this.session.isAuthenticated
    ? ''
    : 'public/';

    return this.api.post(`${prefix}locations`, options).then((response) => {
      const store = this.store;
      store.pushPayload(response);
      return store.peekRecord('location', response.data.id);
    });
  },

  /**
   * Create a valid Location model from one of the records supplied by our google places input.
   *
   * @param {Location} locationRecord   Supplied from the google-places input
   * @param {Array<String>} opt_includes
   * @return {Ember.RSVP.Promise}
   */
  createLocationFromLocationRecord(locationRecord, opt_includes = []) {
    const options = {
      jsonData: {
        'place_id': locationRecord.place_id,
      },
    };

    const prefix = this.session.isAuthenticated
      ? ''
      : 'public/';

    return this.api.post(`${prefix}locations`, this.shData.addIncludesToOptions(options, opt_includes)).then((response) => {
      this.shData.pushResponseToStore(response);

      return this.store.peekRecord('location', response.data.id);
    }).catch((e) => {
      handleErrorResponseWithModal(
        this,
        e,
        'There was an error creating this location. Please refresh and try again.',
        'createLocationFromLocationRecord -- error updating location placeId: ' + locationRecord.place_id,
      );
      throw e;
    });
  }
});
